<div class="co4-wrapper">
    <div class="suggested-resources">
        <div class="container-fluid top">
            <div class="container-xxxl">
                <div class="row pt-5">
                    <div class="col">
                        <div class="container-fluid pb-32">
                            <div class="row">
                                <h2 class="section-heading text-maroon border-maroon">{{ textHeader }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row summary mb-3 pb-3 mb-lg-5 pb-lg-0">
                    <div class="col p-0 fs-md-18">
                        <p class="mb-0">{{ summary }}</p>
                    </div>
                </div>
            </div>
        </div>
        <button-detail-list-section [tabs]="tabs"></button-detail-list-section>
    </div>
</div>
